// extracted by mini-css-extract-plugin
export default {"restart":"AsideElementRestart_restart__r-bTc"};